var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"details"},[_c('div',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.item.privateNote || '')}}),_c('div',{staticClass:"date"},[(_vm.practitioner)?[_vm._v(" "+_vm._s(_vm.practitioner)+" ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.date)+" ")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }